import { merge } from 'lodash';
import { AppConfig } from '../types';

export const defaultAppConfig: AppConfig = {
  title: 'PushStart',

  theme: {
    overrides: {
      core: {
        primary: '#ffffff',
      },
    },
    images: {
      logoPushStart: './static/themes/default/logo-pushstart.png',
      logoProgram: './static/themes/default/logo-program.png',
      logoPartner: './static/themes/default/logo-partner.png',
    },
  },

  accessMode: 'hash',

  game: {
    url: 'game/',
    aspectRatio: '9x16',
  },
};

export const devAppConfig: Partial<AppConfig> = {};
if (process.env.NODE_ENV === 'development') {
  merge(devAppConfig, {
    // Add development-only config here
    accessMode: 'hash',
    game: {
      url: 'https://pushstart.com.br/game/',
    },
  });
}
